<div class="main-container">
    <p-toast></p-toast>
    <mat-card class="cardWithShadow">
        <mat-card-header>
            <div class="flex-container-space-between">
                <div class="flex-container">
                    <mat-card-title>{{ "TOTAL_USERS" | translate }} ({{ this.clientUsers.length }})</mat-card-title>
                    <span class="subtitle">{{ "USERS_REGISTERED_ACCOUNT" | translate }}</span>
                </div>
                <div style="display: flex; gap: 15px; align-items: center;">
                    <mat-form-field appearance="outline" class="w-100 hide-hint">
                        <input matInput (keyup)="applyFilter($event)" placeholder="{{ 'SearchHere' | translate }}"
                            #input />
                    </mat-form-field>
                    <button mat-mini-fab color="primary" (click)="openCreateUserModal(this.client)"
                        matTooltip="{{ 'Add' | translate}}"><i class="fa fa-plus"></i>
                        <mat-icon>add</mat-icon></button>
                </div>
            </div>
        </mat-card-header>

        <mat-card-content>
            <div class="card-body">
                <div class="loading" *ngIf="loading">
                    <ngx-skeleton-loader [count]="10" [theme]="{ 'border-radius': '0', height: '50px' }"
                        [appearance]="'line'">
                    </ngx-skeleton-loader>
                </div>

                <!-- <ngx-datatable *ngIf="!loading" #myTable class="material expandable" style="height: 600px" [columnMode]="'flex'"
                [canAutoResize]="false" [headerHeight]="50" [footerHeight]="50" rowHeight="auto" [rowWidth]="500"
                [rowHeight]="120" [scrollbarV]="true" [scrollbarH]="true" (activate)="onRowClick($event)"
                [rows]="clientUsers" [messages]="{ emptyMessage: 'Data not found.' }">
    
                <ngx-datatable-column name="{{ 'NAME' | translate }}" [sortable]="false" [flexGrow]="0.012">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                        <div class="d-flex flex-column gap-1">
                            <span class="font-bold" [class.selected-row]="row === selectedUser">{{
                                row.name
                                }}</span>
                            <span>{{
                                row.email
                                }}</span>
                            <button class="btn btn-primary" style="width: 185px; font-size: x-small;"
                                (click)="resetPassword(row)"> {{ 'RESET_IOS_PASSWORD' | translate }} <i
                                    class="fa fa-key"></i></button>
                        </div>
                    </ng-template>
                </ngx-datatable-column>
    
                <ngx-datatable-column *ngIf="this.user.role === 'ROLE_CUSTOMER'" name="Email" [sortable]="false"
                            [flexGrow]="0.020">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                <span>{{
                                    row.email
                                    }}</span>
                            </ng-template>
                        </ngx-datatable-column>
    
    
                <ngx-datatable-column name="{{ 'ASSIGNED_CLINICS' | translate }}" [sortable]="false" [flexGrow]="0.010"
                    style="display: flex; justify-content: center; align-items: center;">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                        <span *ngIf="clinics && clinics.length > 0">
                            <button class="btn btn-primary" (click)="openAssignedClinicsModal(row)">
                                {{ "CLINICS" | translate }}
                                <i class="mdi mdi-hospital-building"></i>
                            </button>
                        </span>
    
                    </ng-template>
                </ngx-datatable-column>
    
            </ngx-datatable> -->

                <div class="table-responsive">
                    <table mat-table *ngIf="!loading" [dataSource]="filteredClientUsers" class="mat-elevation-z8">

                        <!-- Name Column -->
                        <ng-container matColumnDef="name">
                            <th mat-header-cell *matHeaderCellDef>{{ 'NAME' | translate }}</th>
                            <td mat-cell *matCellDef="let row" [class.selected-row]="row === selectedUser">
                                <div class="flex-column">
                                    <span class="font-bold">{{ row.name }}</span>
                                    <span>{{ row.email }}</span>
                                    <button mat-raised-button color="primary" class="reset-btn"
                                        (click)="resetPassword(row)">
                                        {{ 'RESET_IOS_PASSWORD' | translate }}
                                        <mat-icon>vpn_key</mat-icon>
                                    </button>
                                </div>
                            </td>
                        </ng-container>

                        <!-- Assigned Clinics Column -->
                        <ng-container matColumnDef="assignedClinics">
                            <th mat-header-cell *matHeaderCellDef>{{ 'ASSIGNED_CLINICS' | translate }}</th>
                            <td mat-cell *matCellDef="let row">
                                <button mat-raised-button color="primary" *ngIf="clinics?.length"
                                    (click)="openAssignedClinicsModal(row)">
                                    {{ "CLINICS" | translate }}
                                    <mat-icon>apartment</mat-icon>
                                </button>
                            </td>
                        </ng-container>

                        <!-- Table Headers & Rows -->
                        <tr mat-header-row *matHeaderRowDef="['name', 'assignedClinics']"></tr>
                        <tr mat-row *matRowDef="let row; columns: ['name', 'assignedClinics'];"
                            (click)="onRowClick(row)">
                        </tr>
                    </table>
                </div>
            </div>

            <!-- Sidebar with user permissions -->
            <!-- <p-sidebar [(visible)]="sidebarVisible" position="right">
            <ng-template pTemplate="header">
                <div style="text-align: center;">
                    <h3 style="margin-right: 150px;">{{ selectedUser.name }}</h3>
                </div>
            </ng-template>
            <div class="mt-1">
                <p-card [style]="{'border': '2px solid grey', 'background-color': '#FAFAFA'}">
                    <ng-container *ngIf="selectedUser">
                        <h5 class="mb-4 text-center">{{ "Current permissions" | translate }}:</h5>
                        <div *ngIf="selectedUser.permissions" class="d-flex flex-column align-items-center">
                            <ul>
                                <li *ngFor="let permission of allPermissions">
                                    <label class="d-flex flex-column gap-2">
                                        <input type="checkbox" [checked]="permission && isPermissionSelected(permission)"
                                            (change)="togglePermissions(permission, $event)">
                                        {{ permission }}
                                    </label>
                                </li>
                            </ul>
                        </div>
                        <div *ngIf="selectedUser.permissions === undefined">
                            {{ "This user has no permissions." | translate }}
                        </div>
                        <div class="col-12 mt-4 d-flex justify-content-center" *ngIf="selectedUser.permissions">
                            <button type="button" class="btn btn-rounded btn-block btn-success"
                                (click)="update(selectedUser)">Update permissions</button>
                        </div>
                    </ng-container>
                </p-card>
            </div>
        </p-sidebar> -->
        </mat-card-content>
    </mat-card>

    <!-- Assigned Clincs Information Modal -->
    <p-dialog header="{{ 'ASSIGNED_CLINICS' | translate }}" [(visible)]="assignedClinicsModalVisible"
        [style]="{width: '50vw', height: '70vh'}" [modal]="true">
        <ng-template pTemplate="header">
            <div style="text-align: center;">
                <h3 style="margin-right: 150px;">{{ "ASSIGNED_CLINICS_OF" | translate }} {{ selectedUser.name }}:</h3>
            </div>
        </ng-template>
        <div class="mt-1">

            <ng-container *ngIf="selectedUser">
                <div *ngIf="clinics" class="d-flex flex-column align-items-center">

                    <div class="d-flex gap-2">
                        <mat-card class="cardWithShadow theme-card" style="margin-top: 5px;">
                            <label style="padding: 10px;">
                                <input type="checkbox" [checked]="selectedUser.allClinicsAssigned"
                                    (change)="toggleAllClinicsSelection($event)">
                                {{ "ALL_THE_CLINICS" | translate }}</label>
                        </mat-card>
                    </div>
                    <div class="clinics-grid" *ngIf="!selectedUser.allClinicsAssigned">
                        <div *ngFor="let clinic of clinics">
                            <mat-card class="cardWithShadow theme-card">
                                <label class="d-flex gap-2 justify-content-center" style="padding: 10px;">
                                    <input type="checkbox" [checked]="isClinicSelected(clinic)"
                                        (change)="toggleClinicSelection(clinic, $event)">
                                    {{ clinic.name }}
                                </label>
                            </mat-card>
                        </div>
                    </div>

                </div>
                <div class="d-flex justify-content-center mt-4 text-center"
                    *ngIf="!selectedUser.assignedClinics || selectedUser.assignedClinics.length === 0">
                    {{ 'THIS_USER_HAS_NO_ASSIGNED_CLINICS' | translate }}
                </div>
            </ng-container>

        </div>
    </p-dialog>

    <!-- Create user modal -->
    <p-dialog header="{{ 'CREATE_USER' | translate }}" [(visible)]="createUserModalVisible">
        <!-- // Falta ngSubmit -->
        <form [formGroup]="createUserForm" (ngSubmit)="createUser()">
            <div class="form-group">
                <label>{{ 'CLIENT_DETAILS.USERS.FULL_NAME' | translate }}</label>
                <input type="text" class="form-control" formControlName="fullName" id="fullName">
            </div>

            <div class="form-group">
                <label>{{ 'EMAIL' | translate }}</label>
                <input type="email" class="form-control" formControlName="email" id="email">
            </div>

            <div class="form-group">
                <label>{{ 'PASSWORD' | translate }}</label>
                <input type="password" class="form-control" formControlName="password" id="password"
                    autocomplete="new-password">
            </div>

            <div class="form-group flex-column">
                <label>{{ 'CLINICS' | translate }}</label>
                <div class="select-clinics-container">
                    <p-multiSelect [options]="clinics" formControlName="clinics" optionLabel="name"
                        placeholder="{{ 'SELECT_CLINICS' | translate }}" (onChange)="onClinicChange($event)"
                        [baseZIndex]="10000" appendTo="body" selectedItemsLabel="{0} clinics selected"
                        [maxSelectedLabels]="1">
                    </p-multiSelect>
                    <button type="button" mat-raised-button color="primary" (click)="toggleSelectAll()">
                        {{ allClinicsSelected ? ('DESELECT_ALL' | translate) : ('SELECT_ALL' | translate) }}
                    </button>
                </div>
            </div>

            <div class="d-flex justify-content-center align-items-center mt-30">
                <button type="submit" mat-raised-button color="primary" [disabled]="createUserForm.invalid">{{ 'CREATE'
                    |
                    translate }}</button>
            </div>
        </form>
    </p-dialog>
</div>